import { createSelector } from 'reselect';
import { academicYearsTouchedSelector, chosenAcademicYearOptionsSelector } from 'selectors/drawers/linkSharingDrawer';

import { createAcademicYearsSelectOptions } from '../../utils/createAcademicYearsSelectOptions';
import { academicYearsSelector } from './academicYearsSelector';

// Селектор получает данные options, которые будут переданы в Select фильтра
// Если пользователь не трогал комбик, считается, что выбраны все варианты
export const academicYearSelectValueSelector = createSelector(
  [academicYearsSelector, chosenAcademicYearOptionsSelector, academicYearsTouchedSelector],
  (academicYears, chosen, academicYearsTouched) => {
    // По умолчанию должны быть выбраны все options
    if (!academicYearsTouched) {
      return createAcademicYearsSelectOptions(academicYears);
    }

    return chosen;
  },
);
